import script from "./heroSection.vue?vue&type=script&setup=true&lang=js"
export * from "./heroSection.vue?vue&type=script&setup=true&lang=js"

import "./heroSection.vue?vue&type=style&index=0&id=74dbfc5f&lang=scss"

const __exports__ = script;

export default __exports__